export function syncTelegramContentInsets() {
  if (typeof document === 'undefined') {
    return
  }

  const tg = window.Telegram?.WebApp
  const safe = tg?.safeAreaInset ?? {}
  const content = tg?.contentSafeAreaInset ?? {}

  const top = (Number(safe.top) || 0) + (Number(content.top) || 0)
  const bottom = (Number(safe.bottom) || 0) + (Number(content.bottom) || 0)

  document.documentElement.style.setProperty('--app-content-top', `${top}px`)
  document.documentElement.style.setProperty('--app-content-bottom', `${bottom}px`)
}

export function bindTelegramSafeAreaInsets() {
  syncTelegramContentInsets()

  const tg = window.Telegram?.WebApp
  if (!tg?.onEvent) {
    return () => {}
  }

  tg.onEvent('safeAreaChanged', syncTelegramContentInsets)
  tg.onEvent('contentSafeAreaChanged', syncTelegramContentInsets)

  return () => {
    tg.offEvent?.('safeAreaChanged', syncTelegramContentInsets)
    tg.offEvent?.('contentSafeAreaChanged', syncTelegramContentInsets)
  }
}
